import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConnectAgodaFlowComponent } from '@app/modules/connected-accounts/pages/connect-agoda-flow/connect-agoda-flow.component';
import { ConnectAirbnbFlowComponent } from '@app/modules/connected-accounts/pages/connect-airbnb-flow/connect-airbnb-flow.component';
import { HasAirbnbEncodedUrlGuard } from './guards/has-airbnb-encoded-url.guard';
import { AirbnbOfficialConnectionErrorComponent } from './pages/airbnb-official-connection-error/airbnb-official-connection-error.component';
import { ConnectAirbnbOfficialFlowComponent } from './pages/connect-airbnb-official-flow/connect-airbnb-official-flow.component';
import { ConnectBookingFlowComponent } from './pages/connect-booking-flow/connect-booking-flow.component';
import { ConnectCompleteComponent } from './pages/connect-complete/connect-complete.component';
import { ConnectFlowTemplateComponent } from './pages/connect-flow-template/connect-flow-template.component';
import { ConnectInviteYourHostsComponent } from './pages/connect-invite-your-hosts/connect-invite-your-hosts.component';
import { ConnectInviteComponent } from './pages/connect-invite/connect-invite.component';
import { ConnectVrboFlowComponent } from './pages/connect-vrbo-flow/connect-vrbo-flow.component';
import { ConnectedAccountsOverviewComponent } from './pages/connected-accounts-overview/connected-accounts-overview.component';
import { DeniedComponent } from './pages/denied/denied.component';
import { ReviewListingsComponent } from './pages/review-listings/review-listings.component';
import { DowngradeAirbnbComponent } from '@app/modules/connected-accounts/pages/downgrade-airbnb/downgrade-airbnb.component';

const routes: Routes = [
  {
    path: '',
    component: ConnectedAccountsOverviewComponent,
    data: {
      title: 'Connected accounts',
    },
  },
  {
    path: 'denied',
    component: DeniedComponent,
  },
  {
    path: '',
    component: ConnectFlowTemplateComponent,
    children: [
      {
        path: 'new/vrbo',
        component: ConnectVrboFlowComponent,
        data: {
          title: 'Connect a Vrbo account',
        },
      },
      {
        path: 'new/airbnb-official/:encodedUrl',
        component: ConnectAirbnbOfficialFlowComponent,
        data: {
          title: 'Connect an Airbnb account',
        },
        canActivate: [HasAirbnbEncodedUrlGuard],
      },
      {
        path: 'new/airbnb-official/:encodedUrl/:login',
        component: ConnectAirbnbOfficialFlowComponent,
        data: {
          title: 'Connect an Airbnb account',
        },
      },
      {
        path: 'new/airbnb',
        component: ConnectAirbnbFlowComponent,
        data: {
          title: 'Connect an Airbnb account',
        },
      },
      {
        path: 'new/booking/:path',
        component: ConnectBookingFlowComponent,
        data: {
          title: 'Connect a Booking.com account',
        },
      },
      {
        path: 'new/booking',
        component: ConnectBookingFlowComponent,
        data: {
          title: 'Connect a Booking.com account',
        },
      },
      {
        path: 'new/agoda',
        component: ConnectAgodaFlowComponent,
        data: {
          title: 'Connect an Agoda account',
        },
      },
      {
        path: 'new/agoda/:path',
        component: ConnectAgodaFlowComponent,
        data: {
          title: 'Connect an Agoda account',
        },
      },
      {
        path: 'new/invite',
        component: ConnectInviteComponent,
        data: {
          title: 'Invite a host',
        },
      },
      {
        path: 'new/invite-your-hosts/:channelId',
        component: ConnectInviteYourHostsComponent,
        data: {
          title: 'Invite a host',
        },
      },
      {
        path: 'new/complete',
        component: ConnectCompleteComponent,
        data: {
          title: 'Complete!',
        },
      },
      {
        path: 'update/vrbo/:channel_id/:username',
        component: ConnectVrboFlowComponent,
        data: {
          title: 'Update your Vrbo account',
        },
      },
      {
        path: 'verify/vrbo/:channel_id/:username/:verify_id',
        component: ConnectVrboFlowComponent,
      },
      {
        path: 'listings/:platform/:channel_id',
        component: ReviewListingsComponent,
        data: {
          title: 'Review your listings',
        },
      },
      {
        path: 'listings/airbnb-official/error/:encodedError',
        component: AirbnbOfficialConnectionErrorComponent,
      },
      {
        path: 'downgrade/airbnb/:channelId',
        component: DowngradeAirbnbComponent,
        data: {
          title: 'Downgrade your connection',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConnectedAccountsRoutingModule {}
